export const scaleIn = (element, options, animationParameters) => {
    var _a, _b, _c, _d;
    const attrs = element.getFinalAnimationAttributes();
    switch (null == options ? void 0 : options.direction) {
      case "x":
        return {
            from: {
                scaleX: 0
            },
            to: {
                scaleX: null !== (_a = null == attrs ? void 0 : attrs.scaleX) && void 0 !== _a ? _a : 1
            }
        };

      case "y":
        return {
            from: {
                scaleY: 0
            },
            to: {
                scaleY: null !== (_b = null == attrs ? void 0 : attrs.scaleY) && void 0 !== _b ? _b : 1
            }
        };

      default:
        return {
            from: {
                scaleX: 0,
                scaleY: 0
            },
            to: {
                scaleX: null !== (_c = null == attrs ? void 0 : attrs.scaleX) && void 0 !== _c ? _c : 1,
                scaleY: null !== (_d = null == attrs ? void 0 : attrs.scaleY) && void 0 !== _d ? _d : 1
            }
        };
    }
};

export const scaleOut = (element, options, animationParameters) => {
    var _a, _b, _c, _d;
    switch (null == options ? void 0 : options.direction) {
      case "x":
        return {
            from: {
                scaleX: null !== (_a = element.getGraphicAttribute("scaleX", !0)) && void 0 !== _a ? _a : 1
            },
            to: {
                scaleX: 0
            }
        };

      case "y":
        return {
            from: {
                scaleY: null !== (_b = element.getGraphicAttribute("scaleY", !0)) && void 0 !== _b ? _b : 1
            },
            to: {
                scaleY: 0
            }
        };

      default:
        return {
            from: {
                scaleX: null !== (_c = element.getGraphicAttribute("scaleX", !0)) && void 0 !== _c ? _c : 1,
                scaleY: null !== (_d = element.getGraphicAttribute("scaleY", !0)) && void 0 !== _d ? _d : 1
            },
            to: {
                scaleX: 0,
                scaleY: 0
            }
        };
    }
};
//# sourceMappingURL=scale.js.map
